<template>
  <div class="row" v-if="can_access('transaction','view')">
    <h1 class="">Deposit/Withdraw</h1>
    <div class="col-sm-12">
      <b-button class="btn-info pull-right" @click="showAddTransactionForm=showAddTransactionForm?false:true" title="Add Transaction" v-if="can_access('transaction','modify')"><i :class="showAddTransactionForm?'fa fa-minus':'fa fa-plus'"></i></b-button>
    </div>
    <div v-if="showAddTransactionForm && can_access('transaction','modify')" style="width:100%">
      <AddTransactionForm :forceRerender="transFormReRender"/>
    </div>
    <TableView :col="columns" :getData="getData" v-if="showAddTransactionList && can_access('transaction','view')"/>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import AddTransactionForm from '@/components/Accounts/AddTransactionForm';
import common from '@/assets/js/common.js';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import TableView from '@/components/Common/DataTable/Table';

export default {
  name: 'TransactionsPage',
  components: { Widget, AddTransactionForm, DatePicker, TableView },
  mixins: [common],
  data() {
    return {
      showAddTransactionForm: 1,
      showAddTransactionList: 1,
      DateFilter: '',
      DownloadURL: '',
      errorMessage: null,
      columns: (() => {
        const cols = [
          { title: 'Acc. No.', field: 'account_number', thComp: 'FilterTh', tdStyle: {padding: this.can_access('transaction','modify')?"":"0.8rem !important"}},
          { title: 'Transaction Date', field: 'transaction_date', thComp: 'FilterTh', sortable: true },
          { title: 'Type', field: 'type_name', thComp: 'FilterTh'},
          { title: 'Currency', field: 'currency', thComp: 'FilterTh'},
          { title: 'Value', field: 'value', thComp: 'FilterTh'},
          { title: 'Comment', field: 'comment', thComp: 'FilterTh'},
          { title: 'Operation', tdComp: 'transOpt', visible: this.can_access('deal','modify'), tdStyle:{'text-align':'center'}, thStyle:{'text-align':'center'} }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  methods: {
    transFormReRender(response) {
      if(response.code==0){
        this.showAddTransactionForm = false;
        this.showAddTransactionList = false;
        this.$nextTick(function(){
          this.showAddTransactionForm = true;
          this.showAddTransactionList = true;
          this.$toasted.success("Successfully Added",{duration:1000});
        });
      }
    },
    async getData(query={}, filter={}) {
      const { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));

      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }
      });
      let uri = 'transaction_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      return await this.call_axios(uri);
    }
  },
  created() {
    
  },
};
</script>